/**
 * Utility functions for handling group join notifications and UI updates
 */

/**
 * Notify all components that a user has joined a group
 * This triggers immediate UI updates across the application
 */
export const notifyGroupJoined = (groupId, userId) => {
  // Dispatch custom event for immediate UI updates
  window.dispatchEvent(
    new CustomEvent("groupJoined", {
      detail: { groupId, userId },
    }),
  );

  // Also dispatch a more specific event for different components
  window.dispatchEvent(
    new CustomEvent("userGroupsUpdated", {
      detail: { groupId, userId, action: "joined" },
    }),
  );
};

/**
 * Notify all components that a user has left a group
 */
export const notifyGroupLeft = (groupId, userId) => {
  window.dispatchEvent(
    new CustomEvent("groupLeft", {
      detail: { groupId, userId },
    }),
  );

  window.dispatchEvent(
    new CustomEvent("userGroupsUpdated", {
      detail: { groupId, userId, action: "left" },
    }),
  );
};

/**
 * Force refresh user channels after group operations
 */
export const refreshUserChannels = async (userId) => {
  try {
    const { refreshUserChannels } = await import(
      "../services/streamConnectionService"
    );
    await refreshUserChannels(userId);
  } catch (error) {
    console.error("Error refreshing user channels:", error);
  }
};

/**
 * Comprehensive group join handler that ensures all UI updates happen
 */
export const handleGroupJoinComplete = async (groupId, userId) => {
  notifyGroupJoined(groupId, userId);


  console.log(`Group join completed for user ${userId}, group ${groupId}`);
};

const groupJoinNotificationUtils = {
  notifyGroupJoined,
  notifyGroupLeft,
  refreshUserChannels,
  handleGroupJoinComplete,
};

export default groupJoinNotificationUtils;
